import React from "react";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

import { String } from "./String";

function StringControl({
  data,
  label,
  required,
  path,
  handleChange,
  errors,
}: ControlProps): JSX.Element {
  return (
    <String
      value={data}
      label={label}
      required={required}
      updateValue={(value: string | undefined) => handleChange(path, value)}
      errors={errors}
    />
  );
}

export default withJsonFormsControlProps(StringControl);
